
import { Component, OnInit, ChangeDetectionStrategy, output } from '@angular/core';
import { TranslateModule,  } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';


@Component({
  selector: 'no-client-trial-booking',
  templateUrl: './no-client-trial-booking.component.html',
  standalone: true,
  imports: [
    ButtonModule,
    TranslateModule
],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NoClientTrialBookingComponent {
  readonly onAction = output<{ action: string }>();
  
  constructor() { }

  addTrialBooking(){
    this.onAction.emit({action:"createclientrialclassbooking"});
  }

}

